/* ========================================================================
 * DOM-based Routing
 * Based on https://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    $(function () {
        FastClick.attach(document.body);
    });

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                $('video').click(function () {

                    var video = $(this).get(0);
                    if (video.paused === false) {
                        video.pause();
                    } else {
                        video.play();
                    }

                    return false;

                });

                $("#meetmavenscroll").click(function () {

                    $('html, body').animate({
                        scrollTop: $("#meet-our-crew").offset().top
                    }, 1037);
                    // $( "#meet-our-crew" ).scroll();
                    event.preventDefault();
                    return false;
                });

                var vidright = document.getElementById("maven-video-right");
                var vidleft = document.getElementById("maven-video-left");

                function leftexpand(e) {
                    vidright.pause();
                    $('#left-tile-section').removeClass('col-sm-5');
                    $('#left-tile-section').removeClass('col-sm-3');
                    $('#left-tile-section').removeClass('col-sm-4');
                    $('#left-tile-section').addClass('col-sm-8');

                    $('#right-tile-section').removeClass('col-sm-7');
                    $('#right-tile-section').removeClass('col-sm-5');
                    $('#right-tile-section').removeClass('col-sm-8');
                    $('#right-tile-section').removeClass('col-sm-4');
                    $('#right-tile-section').addClass('col-sm-4');

                }

                //$('#left-tile-section').click(leftexpand);

                function rightexpand(e) {
                    vidleft.pause();
                    $('#right-tile-section').removeClass('col-sm-5');
                    $('#right-tile-section').removeClass('col-sm-3');
                    $('#right-tile-section').removeClass('col-sm-4');
                    $('#right-tile-section').addClass('col-sm-8');

                    $('#left-tile-section').removeClass('col-sm-7');
                    $('#left-tile-section').removeClass('col-sm-8');
                    $('#left-tile-section').removeClass('col-sm-5');
                    $('#left-tile-section').removeClass('col-sm-4');
                    $('#left-tile-section').addClass('col-sm-4');
                }

                function homevideoclosed(e) {
                    vidleft.pause();
                    vidright.pause();
                    $('#right-tile-section').removeClass('col-sm-5');
                    $('#right-tile-section').removeClass('col-sm-3');
                    $('#right-tile-section').removeClass('col-sm-4');

                    $('#left-tile-section').removeClass('col-sm-7');
                    $('#left-tile-section').removeClass('col-sm-8');
                    $('#left-tile-section').removeClass('col-sm-5');
                    $('#left-tile-section').removeClass('col-sm-4');
                    $('#right-tile-section').removeClass('col-sm-5');
                    $('#right-tile-section').removeClass('col-sm-3');
                    $('#right-tile-section').removeClass('col-sm-4');


                    $('#left-tile-section').removeClass('col-sm-5');
                    $('#left-tile-section').removeClass('col-sm-3');
                    $('#left-tile-section').removeClass('col-sm-4');

                    $('#right-tile-section').removeClass('col-sm-7');
                    $('#right-tile-section').removeClass('col-sm-5');
                    $('#right-tile-section').removeClass('col-sm-8');
                    $('#right-tile-section').removeClass('col-sm-4');

                    $('#left-tile-section').removeClass('col-sm-7');
                    $('#left-tile-section').removeClass('col-sm-8');
                    $('#left-tile-section').removeClass('col-sm-5');
                    $('#left-tile-section').removeClass('col-sm-4');

                    $('#left-tile-section').addClass('col-sm-5');
                    $('#right-tile-section').addClass('col-sm-7');
                }

                $('#close-left-video').click(function () {
                    homevideoclosed();
                });
                $('#close-right-video').click(function () {
                    homevideoclosed();
                });

                $('.tile1').click(function () {
                    leftexpand();
                    $('#mcf-left').attr("src", "https://www.madcoolfitness.com/static/jennifer.mp4");
                    vidleft.load();
                    vidleft.play();
                });

                $('.tile2').click(function () {
                    rightexpand();
                    $('#mcf-right').attr("src", "https://www.madcoolfitness.com/static/octavia.mp4");
                    vidright.load();
                    vidright.play();
                });

                $('.tile3').click(function () {
                    rightexpand();
                    $('#mcf-right').attr("src", "https://www.madcoolfitness.com/static/juan.mp4");
                    vidright.load();
                    vidright.play();
                });

                $('.tile5').click(function () {
                    rightexpand();
                    $('#mcf-right').attr("src", "https://www.madcoolfitness.com/static/lisa.mp4");
                    vidright.load();
                    vidright.play();
                });
                $('.tile6').click(function () {
                    rightexpand();
                    $('#mcf-right').attr("src", "https://www.madcoolfitness.com/static/esther.mp4");
                    vidright.load();
                    vidright.play();
                });






// LOGIN PAGE
                function loginswap(e) {
                    $('#sign-up-toggle').toggleClass('inactive-login');
                    $('#login-toggle').toggleClass('inactive-login');

                    $('#login-row').toggleClass('hidden');
                    $('#register-row').toggleClass('hidden');
                }
                $('#sign-up-toggle').click(loginswap);
                $('#login-toggle').click(loginswap);
                $('.logintogglememe').click(loginswap);

                if (window.location.hash) {
                    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

                    switch (hash) {
                        case 'login':
                            $('#sign-up-toggle').addClass('inactive-login');
                            $('#login-toggle').removeClass('inactive-login');

                            $('#login-row').removeClass('hidden');
                            $('#register-row').addClass('hidden');
                            break;
                        case 'signup':
                            $('#sign-up-toggle').removeClass('inactive-login');
                            $('#login-toggle').addClass('inactive-login');

                            $('#login-row').addClass('hidden');
                            $('#register-row').removeClass('hidden');
                            break;
                    }
                }

                $('.js-open-search').click(function () {
                    $('.search-container').toggleClass('show');
                    return false;
                });
                $('.js-close-search').click(function () {
                    $('.search-container').removeClass('show');
                    return false;
                });


                (function ($) {
                    $(function () {
                        var $output = $("#output"),
                                scrolling = "<span id='scrolling'>Scrolling</span>",
                                stopped = "<span id='stopped'>Stopped</span>";


                        $(window).scroll(function () {

                            console.log(window.pageYOffset);


                            if (window.pageYOffset > 15) {
                                //  fade out the call out message

                                $("#parallax-home-overlay").css("opacity", 0);
                                setTimeout(function () {
                                    $("#parallax-home-overlay").css("display", "none");
                                }, 1500);
                            }

                            $output.html(scrolling);
                            clearTimeout($.data(this, "scrollCheck"));
                            $.data(this, "scrollCheck", setTimeout(function () {


                                var y_scroll_pos = window.pageYOffset;
                                var scroll_pos_test = 150;

                                if (y_scroll_pos > scroll_pos_test) {
                                    //Shrink nav


                                    if ($(window).width() >= 767) {
                                        // adjust padding for desktop only

                                        // $(".tile4").height("calc(40vh - 50px)");
                                        // $(".tile5").height("calc(60vh - 50px)");
                                        // $(".tile6").height("calc(40vh - 50px)");

                                        $("body").animate({
                                            paddingTop: 125
                                        }, 500, function () {
                                            // Animation complete.

                                        });
                                    }

                                    $(".navbar-fixed-top .nav").animate({
                                        padding: 0
                                    }, 500, function () {
                                        // Animation complete.

                                    });

                                    $("#logo").animate({
                                        height: 55
                                    }, 500, function () {
                                        // Animation complete.
                                        $("#logo").attr('src', 'https://www.madcoolfitness.com/wp-content/themes/madcoolfitness/assets/images/mini-logo.png');
                                    });

                                    $("#mini-logo").animate({
                                        height: 55
                                    }, 500, function () {
                                        // Animation complete.
                                        $("#mini-logo").attr('src', 'https://www.madcoolfitness.com/wp-content/themes/madcoolfitness/assets/images/mini-logo.png');
                                    });

                                }


                                if (y_scroll_pos < scroll_pos_test) {
                                    //do stuff
                                    //console.log('TOP SCROLL Event Fired');



                                    if ($(window).width() >= 767) {
                                        // adjust padding only for desktop not phones

                                        // $(".tile4").height("calc(40vh - 80px)");
                                        // $(".tile5").height("calc(60vh - 80px)");
                                        // $(".tile6").height("calc(40vh - 80px)");

                                        $("body").animate({
                                            paddingTop: 155
                                        }, 500, function () {
                                            // Animation complete.

                                        });
                                    }
                                    $("#logo").animate({
                                        height: 92
                                    }, 500, function () {
                                        // Animation complete.
                                        $("#logo").attr('src', 'https://www.madcoolfitness.com/wp-content/themes/madcoolfitness/assets/images/logo.png');
                                    });
                                    $("#mini-logo").animate({
                                        height: 70
                                    }, 500, function () {
                                        // Animation complete.
                                        $("#mini-logo").attr('src', 'https://www.madcoolfitness.com/wp-content/themes/madcoolfitness/assets/images/logo.png');
                                    });



                                    $(".navbar-fixed-top .nav").animate({
                                        paddingTop: 15,
                                        paddingBottom: 15
                                    }, 500, function () {
                                        // Animation complete.

                                    });

                                }


                            }, 250));

                        });

                    });

                })(jQuery);

//         $(window).on('scroll', function() {
//     var y_scroll_pos = window.pageYOffset;
//     var scroll_pos_test = 150;             // set to whatever you want it to be
//
//
//
// });
                $('#main').on('scroll', function () { });

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Quiz page
        'quiz': {
            init: function () {
                // JavaScript to be fired on the quiz page
            },
            finalize: function () {
                // JavaScript to be fired on the quiz page, after the init JS


                var disabled = false;
                var q1 = 0;
                var q2 = 0;
                var quiznum = 0;
                var progress = 6.6;

                // PC Stage = 1, 5, 10
                var pcstage = 0;
                // C Stage = 3, 8,12
                var cstage = 0;
                // P Stage = 6, 9,13
                var pstage = 0;
                // A Stage = 4, 11, 14
                var astage = 0;
                // M Stage = 2, 7, 15
                var mstage = 0;

                var stages = [
                    {name: "cstage", title: "Contemplation", video: "q_k-lQO11XA", score: 0},
                    {name: "pcstage", title: "Relapse", video: "hyXRIlozcns", score: 0},
                    {name: "pstage", title: "Preparation", video: "-azkDZqsPm0", score: 0},
                    {name: "astage", title: "Action", video: "Q3rIabLpbhU", score: 0},
                    {name: "mstage", title: "Maintenance", video: "0KnZb7PGXO8", score: 0},
                ];

                //giving hover fx mobile support
                $('.quiz-buttons .btn').on('touchstart mouseover', function (e) {
                    $(this).addClass('focus');
                });
                
                $('.quiz-buttons .btn').on('mouseout', function (e) {
                    $(this).removeClass('focus');
                });

                // function that fires when user makes quiz question TRUE
                $(".quiz-true").on('touchend click', function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    $(this).removeClass('focus');
                    if (disabled === true) {
                        return false;
                    }

                    // PC Stage = 1, 5, 10
                    if (quiznum === 1 || quiznum === 5 || quiznum === 10) {
                        pcstage++;
                        stages[0].score++;
                    }
                    // C Stage = 3, 8,12
                    if (quiznum === 3 || quiznum === 8 || quiznum === 12) {
                        cstage++;
                        stages[1].score++;
                    }
                    // P Stage = 6, 9,13
                    if (quiznum === 6 || quiznum === 9 || quiznum === 13) {
                        pstage++;
                        stages[2].score++;
                    }
                    // A Stage = 4, 11, 14
                    if (quiznum === 4 || quiznum === 11 || quiznum === 14) {
                        astage++;
                        stages[3].score++;
                    }
                    // M Stage = 2, 7, 15
                    if (quiznum === 2 || quiznum === 7 || quiznum === 15) {
                        mstage++;
                        stages[4].score++;
                    }

                    $("#q" + quiznum).fadeOut("slow");
                    quiznum++;
                    $("#q" + quiznum).fadeIn("slow");


                    $(".progress-bar").width(progress * quiznum + "%");
                    $("#quiz-number").html(quiznum);

                    // IF Quiz Stage = 16 move on to get results and assement section
                    if (quiznum > 15) {
                        disabled = true;
                        $(".progress-row").fadeOut("slow");
                        $(".quiz-buttons-tf").fadeOut("slow");
                        if ($(window).width() < 500) {
                            // adjust only for mobile phones not  desktop
                            $("div.quiz-header-container").animate({
                                height: "105"
                            }, 600, function () {
                                // Animation complete.
                            });
                        }
                        $("#quiz-header").html('GET YOUR READINESS QUIZ RESULTS!');

                        // $( "#quiz-area" ).animate({
                        //   height: 505
                        // }, 500, function() {
                        //   // Animation complete.
                        // //  $('html, body').animate({ scrollTop: $( '#quiz' ).offset().top - $( '.navbar' ).height()    }, 500);
                        //
                        // });

                    }

                });

                // function that fires when user makes quiz question FALSE
                $(".quiz-false").on('touchend click', function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    $(this).removeClass('focus');
                    if (disabled === true) {
                        return false;
                    }

                    $("#q" + quiznum).fadeOut("slow");
                    quiznum++;
                    $("#q" + quiznum).fadeIn("slow");
                    $(".progress-bar").width(progress * quiznum + "%");
                    $("#quiz-number").html(quiznum);

                    // IF Quiz Stage = 16 move on to get results and assement section
                    if (quiznum > 15) {
                        disabled = true;
                        $(".progress-row").fadeOut("slow");
                        $(".quiz-buttons-tf").fadeOut("slow");

                        $("#quiz-header").html('GET YOUR READINESS QUIZ RESULTS!');

                        // $( "#quiz-area" ).animate({
                        //   // height: 485
                        //   height: inherit
                        // }, 500, function() {
                        //   // Animation complete.
                        // //  $('html, body').animate({ scrollTop: $( '#quiz' ).offset().top - $( '.navbar' ).height()    }, 500);
                        //
                        // });

                    }

                });






                // function that fires when user starts the quiz
                $("#take-quiz").click(function () {

                    //$("body").fadeOut("slow");
                    quiznum++;
                    $("#quiz-intro").animate({
                        opacity: 0,
                        padding: 0,
                        height: "toggle"
                    }, 500, function () {
                        // Animation complete.
                        //  $('html, body').animate({ scrollTop: $( '#quiz' ).offset().top - $( '.navbar' ).height()    }, 500);
                    });

                    $("#q0").animate({
                        opacity: 0,
                        padding: 0,
                        height: "toggle"
                    }, 500, function () {
                        // Animation complete.
                        //  $('html, body').animate({ scrollTop: $( '#quiz' ).offset().top - $( '.navbar' ).height()    }, 500);

                    });

                    if ($(window).width() >= 500) {
                        // adjust only for desktop not mobile phones
                        $("div.container-full.page-cover").animate({
                            height: "toggle"
                        }, 600, function () {
                            // Animation complete.
                        });
                    }


                    if ($(window).width() < 500) {
                        // adjust only for mobile phones not  desktop
                        $("div.quiz-header-container").animate({
                            height: "70"
                        }, 600, function () {
                            // Animation complete.
                        });
                    }



                    setTimeout(function () {
                        $("html, body").animate({scrollTop: 0}, "fast");
                    }, 700);


                    $("#q0").animate({
                        opacity: 0,
                        padding: 0,
                        display: "toggle"
                    }, 500, function () {
                        // Animation complete.
                    });
                    $("#q1").fadeIn("slow");
                    $("#quiz-number").html(quiznum);
                    $("#quiz-header-intro").fadeOut("slow");

                    $("#quiz-header").fadeIn("slow");

                    $(".quiz-buttons-start").fadeOut("slow");
                    $(".quiz-buttons-tf").fadeIn("slow");

                    $(".progress-bar").width('6%');

                });





                // function that fires when user clicks GET RESULTS
                $("#quiz-results").click(function () {

                    var email = $('#email-quiz').val();
                    var name = $('#name').val();
                    var last = $('#last').val();
                    var formStatus = $('#quizFormStatus');

                    if (!name) {
                        $("#name").css('border', 'solid 3px #ee3a43');
                        $("#fname-required").css('visibility', 'visible');
                        setTimeout(function () {
                            // $("#fname-required").css('visibility','hidden');
                            $("#name").css('border', 'solid 3px #a2a1a2');
                        }, 3000);
                        return false;
                    }

                    if (!last) {
                        $("#last").css('border', 'solid 3px #ee3a43');
                        $("#lname-required").css('visibility', 'visible');
                        setTimeout(function () {
                            // $("#lname-required").css('visibility','hidden');
                            $("#last").css('border', 'solid 3px #a2a1a2');
                        }, 3000);
                        return false;
                    }

                    if (!email) {
                        $("#email-quiz").css('border', 'solid 3px #ee3a43');
                        $("#email-required").css('visibility', 'visible');
                        setTimeout(function () {
                            // $("#email-required").css('visibility','hidden');
                            $("#email-quiz").css('border', 'solid 3px #a2a1a2');
                        }, 3000);
                        return false;
                    }

                    //pre calculate final state so we can pass to MailChimp
                    var currentStage;

                    for (var i = 0; i < stages.length; i++) {
                        if (i === 0) {
                            currentStage = stages[i];
                        } else if (stages[i].score > currentStage.score) {
                            currentStage = stages[i];
                        }
                    }

                    $(document).ready(function ($) {

                        formStatus.text('Submitting form...');

                        var data = {
                            'action': 'mcf_quiz',
                            'name': name,
                            'last': last,
                            'email': email,
                            'stateTitle': currentStage.title
                        };
                        // We can also pass the url value separately from ajaxurl for front end AJAX implementations
                        $.post(quiz_ajaxurl, data, function (response) {

                            if (response === 'success' || response === 'member_exists') {

                                //alert(response);

                                formStatus.text('');

                                $("#q16").fadeOut("slow");

                                $("#q17").fadeIn("slow");

                                var videoplayer = 'https://www.youtube.com/embed/' + currentStage.video + '?autoplay=1&rel=0';

                                $("#quizvideoframe").attr('src', videoplayer);
                                $("#video-area").fadeIn("slow");

                                $("#quiz-header").html('<span id="quiz-final">YOUR STAGE OF READINESS IS...</span><br>' + currentStage.title);
                                $("#quiz-header").css('margin-top', '-10px');
                                $('html, body').animate({scrollTop: 0}, 'slow');
                                if ($(window).width() < 500) {
                                    $(".quiz-questions").css('padding', '0px');
                                    $(".quiz-container").css('padding', '0px');

                                    $(".quiz-buttons").css('height', '0px');
                                    // adjust only for mobile phones not  desktop
                                    $("div.quiz-header-container").animate({
                                        height: "75"
                                    }, 600, function () {
                                        // Animation complete.
                                    });
                                }
                                $("#quiz-share").animate({
                                    display: "block",
                                    height: "toggle"
                                }, 500, function () {

                                });

                            } else if (response.indexOf('issue') !== false) {

                                formStatus.text('There was an issue submitting your form, please try again.');

                                setTimeout(function () {

                                    formStatus.text('');

                                }, 150000);

                            } else {

                                //  $( "#email-required" ).replaceWith( '<span id="email-required">' + response + '</span>' );
                                $("#email-required").replaceWith('<span id="email-required">Please double check your email address.</span>');

                                $("#email-quiz").css('border', 'solid 3px #ee3a43');
                                $("#email-required").addClass('required');
                                $("#email-required").css('visibility', 'visible');
                                setTimeout(function () {
                                    // $("#email-required").css('visibility','hidden');
                                    $("#email-quiz").css('border', 'solid 3px #a2a1a2');
                                    formStatus.text('');
                                }, 3000);

                                return false;
                                //alert(response);

                            }

                        });
                    });



                    event.preventDefault();
                    return false;

                });

            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page

                //.discover-callout, .shop-callout, .wellness-callout, .class-callout
                $(".discover-callout").click(function () {
                    var discover_href = $("#discover-callout-link").attr('href');
                    window.open(discover_href, "_self");
                });
                // $( ".shop-callout" ).click(function() { 
                //   var shop_href = $( "#shop-callout-link" ).attr('href');
                //   window.open(shop_href, "_self");
                // });
                $(".class-callout").click(function () {
                    var class_href = $("#class-callout-link").attr('href');
                    window.open(class_href, "_self");
                });
                $(".wellness-callout").click(function () {
                    var wellness_href = $("#wellness-callout-link").attr('href');
                    window.open(wellness_href, "_self");
                });

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
